<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_S_square_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="0"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1252"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer2"
     inkscape:document-units="px"
     inkscape:cy="215.04406"
     inkscape:cx="47.910554"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
    <path
       id="outside"
       style="opacity:0.299035;fill:#ff000000;stroke:#ffffff;stroke-width:0.456113;stroke-miterlimit:4;stroke-dasharray:none"
       d="M 30.228516 -0.021484375 L 30.228516 0 L 0.99414062 0 L 0.99414062 400 L 30.228516 400 L 30.228516 400.02148 L 329.77148 400.02148 L 329.77148 400 L 359.61523 400 L 359.61523 0 L 329.77148 0 L 329.77148 -0.021484375 L 30.228516 -0.021484375 z M 224.53906 23.490234 C 235.72887 23.285045 246.77638 31.579548 260.39258 63.570312 C 276.12312 102.36276 274.53433 155.82875 273.58008 200.79688 C 272.62583 245.76499 266.30685 308.16456 251.74023 340.63086 C 237.17362 373.09716 212.19053 373.95117 179.5918 373.95117 C 146.99304 373.95117 122.08711 373.71484 107.63477 341.09961 C 93.182398 308.48436 88.942007 242.36016 86.212891 200.00391 C 83.483775 157.64766 85.820056 110.1141 99.761719 63.021484 C 128.03221 -4.0267456 150.01594 34.732961 182.00195 34.826172 C 198.99452 34.875692 211.85727 23.72278 224.53906 23.490234 z " />
    <path
       id="mouth"
       style="display:inline;fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       d="M 180 8.7871094 C 117.76101 8.7872428 67.307034 23.06088 67.308594 40.667969 C 67.309406 45.291879 80.697418 55.264089 98.300781 63.435547 C 98.341928 63.298166 98.380527 63.160811 98.421875 63.023438 C 127.16389 -4.0241562 149.51565 34.734915 182.03516 34.828125 C 199.31116 34.877643 212.38988 23.72473 225.2832 23.492188 C 236.65965 23.287001 247.89106 31.581804 261.73438 63.572266 C 261.84309 63.835974 261.94173 64.107989 262.04883 64.373047 C 279.21635 56.30584 292.69089 45.301345 292.69141 40.667969 C 292.69297 23.06088 242.23899 8.7872422 180 8.7871094 z " />
  <g id="cover_layer">
   <path
       sodipodi:nodetypes="ssczssszcs"
       inkscape:connector-curvature="0"
       d="M 220.09818,23.386598 C 208.76268,23.594457 197.26484,33.562746 182.07619,33.518485 153.4858,33.435169 133.83488,-1.2088109 108.56557,58.721619 96.103946,100.8149 94.017246,143.30183 96.45664,181.16156 c 2.439395,37.85974 6.2287,96.9641 19.14681,126.11693 12.91809,29.15282 35.18043,29.3638 64.31853,29.3638 29.13806,0 51.46825,-0.76313 64.48848,-29.78282 13.02023,-29.0197 18.66863,-84.79471 19.52158,-124.98904 0.85295,-40.19434 2.27414,-87.983927 -11.78646,-122.658192 -12.17071,-28.594645 -22.04549,-36.009046 -32.0474,-35.82564 z"
       style="fill:none;stroke:#ff000000;stroke-width:1.74111px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       id="cover" />
  </g>
  <g
     inkscape:groupmode="layer"
     id="body_layer"
     inkscape:label="Layer 2">
    <path
       sodipodi:nodetypes="ssczssszcs"
       inkscape:connector-curvature="0"
       d="m 224.53993,23.490391 c -12.68179,0.232546 -25.5452,11.384746 -42.53777,11.335228 -31.98601,-0.09321 -53.97082,-38.8517778 -82.241309,28.196453 -13.941663,47.092608 -16.276196,94.625588 -13.54708,136.981838 2.729116,42.35625 6.968465,108.4803 21.420829,141.09555 14.45234,32.61523 39.35873,32.85127 71.95749,32.85127 32.59873,0 57.58102,-0.85376 72.14763,-33.32006 14.56662,-32.4663 20.88587,-94.86558 21.84012,-139.8337 0.95425,-44.96813 2.54423,-98.43356 -13.18631,-137.226009 -13.6162,-31.990766 -24.66379,-40.285759 -35.8536,-40.08057 z"
       style="fill:#f59a9a;stroke:#ff000000;stroke-width:1.9479px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       id="body" />
    <path
       id="k-bl-li"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.456113;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 224.53993,23.490396 C 211.85814,23.722942 198.99473,34.875142 182.00216,34.825624 150.01615,34.732413 128.03134,-4.0261534 99.760851,63.022077 97.220348,71.603474 95.07744,80.237394 93.279834,88.868663 161.41318,103.40757 216.23067,98.39292 267.72124,88.491669 265.93386,79.754197 263.56497,71.3919 260.39353,63.570966 246.77733,31.5802 235.72974,23.285207 224.53993,23.490396 Z"
       inkscape:connector-curvature="0" />
    <path
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.699429;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 93.209953,89.200732 c -8.00415,38.624138 -9.024775,77.186968 -6.996183,110.803178 0.982792,14.38796 2.087865,31.13782 3.63704,48.28264 2.251573,22.24029 5.300733,44.29909 9.295742,65.31186 6.101608,-5.15658 18.948538,-11.37999 25.004248,-14.41565 C 115.66457,230.66742 113.05045,165.581 122.92545,94.365361 Z"
       inkscape:connector-curvature="0" />
    <path
       sodipodi:nodetypes="ccccc"
       inkscape:connector-curvature="0"
       d="m 99.14665,313.59898 c 3.5833,13.94568 4.70748,21.25922 10.766,32.3383 25.22005,-9.91177 115.56503,-12.49871 139.79384,-0.62096 5.66002,-13.415 8.12991,-21.37641 11.62131,-36.3399 -51.1508,-32.71786 -119.08011,-27.30647 -162.18115,4.62256 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.699429;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lg" />
    <path
       sodipodi:nodetypes="ccccc"
       inkscape:connector-curvature="0"
       d="m 124.1513,299.18287 c -8.48623,-68.51526 -11.10007,-133.6033 -1.22507,-204.818925 41.80774,5.48152 78.62505,4.110931 113.19585,-0.341382 11.52245,75.142737 8.25169,137.585447 -0.84731,201.946607 -47.91346,-16.55574 -86.63025,-6.79489 -111.12347,3.2137 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.699429;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="st-sp" />
    <path
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.456113;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 267.72124,88.491669 c -10.53169,1.959755 -20.81273,3.744705 -31.59916,5.530894 11.52755,75.155257 8.25362,137.577877 -0.84654,201.946947 0,0 15.7615,5.93169 26.05082,13.00534 0.01,-0.0468 0.0193,-0.0938 0.0293,-0.14064 4.24619,-21.0283 7.75264,-50.26096 10.24643,-81.22571 0.004,-0.0484 0.009,-0.0982 0.013,-0.14651 0.003,-0.0428 0.007,-0.0861 0.01,-0.12891 0.0301,-0.37489 0.0579,-0.75366 0.0877,-1.12903 0.26981,-3.48025 0.51976,-6.83799 0.76543,-10.18667 0.39167,-5.47643 0.75143,-10.97597 1.07746,-16.47446 -0.88705,-36.5518 1.01058,-76.97697 -5.83422,-111.051251 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccccscccc" />
    <path
       sodipodi:nodetypes="cscc"
       inkscape:connector-curvature="0"
       d="m 110.56291,345.31632 c 14.68936,27.98563 38.67878,28.21919 69.61335,28.21919 30.75624,0 54.71514,-0.77722 69.53023,-28.21919 -20.11775,-11.40805 -103.32609,-9.9306 -139.14358,0 z"
       style="fill:none;stroke:#00000f;stroke-width:0.698255;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="he" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>